/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {LicenseType} from '../models/LicenseType';
import type {Limit} from '../models/Limit';

export interface GetDefaultLicenseLimits$Request {
    licenseType: LicenseType;
}

export interface GetDefaultLicenseLimits$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getDefaultLicenseLimitsRequest = createAction<PayloadData<void, GetDefaultLicenseLimits$Request>>('LICENSE_LIMITS__GET_DEFAULT_LICENSE_LIMITS__REQUEST');
export const getDefaultLicenseLimitsSuccess = createAction<PayloadData<Array<Limit>, GetDefaultLicenseLimits$Request>>('LICENSE_LIMITS__GET_DEFAULT_LICENSE_LIMITS__SUCCESS');
export const getDefaultLicenseLimitsFailure = createAction<PayloadData<Error, GetDefaultLicenseLimits$Request, true>>('LICENSE_LIMITS__GET_DEFAULT_LICENSE_LIMITS__FAILURE');

export const getDefaultLicenseLimitsActions = [
    getDefaultLicenseLimitsRequest,
    getDefaultLicenseLimitsSuccess,
    getDefaultLicenseLimitsFailure
] as const;

/**
 * @param {LicenseType} meta.licenseType
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getDefaultLicenseLimits = (meta: GetDefaultLicenseLimits$Request, config?: GetDefaultLicenseLimits$Config) => {
    return {
        CALL_API: {
            types: getDefaultLicenseLimitsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/licenses/${meta.licenseType}/default-limits`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetLicenseLimits$Request {
    licenseId: number;
}

export interface GetLicenseLimits$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getLicenseLimitsRequest = createAction<PayloadData<void, GetLicenseLimits$Request>>('LICENSE_LIMITS__GET_LICENSE_LIMITS__REQUEST');
export const getLicenseLimitsSuccess = createAction<PayloadData<Array<Limit>, GetLicenseLimits$Request>>('LICENSE_LIMITS__GET_LICENSE_LIMITS__SUCCESS');
export const getLicenseLimitsFailure = createAction<PayloadData<Error, GetLicenseLimits$Request, true>>('LICENSE_LIMITS__GET_LICENSE_LIMITS__FAILURE');

export const getLicenseLimitsActions = [
    getLicenseLimitsRequest,
    getLicenseLimitsSuccess,
    getLicenseLimitsFailure
] as const;

/**
 * @param {number} meta.licenseId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getLicenseLimits = (meta: GetLicenseLimits$Request, config?: GetLicenseLimits$Config) => {
    return {
        CALL_API: {
            types: getLicenseLimitsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/licenses/${meta.licenseId}/limits`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UpdateLicenseLimits$Request {
    licenseId: number;
    limit: Array<Limit>;
}

export interface UpdateLicenseLimits$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateLicenseLimitsRequest = createAction<PayloadData<void, UpdateLicenseLimits$Request>>('LICENSE_LIMITS__UPDATE_LICENSE_LIMITS__REQUEST');
export const updateLicenseLimitsSuccess = createAction<PayloadData<void, UpdateLicenseLimits$Request>>('LICENSE_LIMITS__UPDATE_LICENSE_LIMITS__SUCCESS');
export const updateLicenseLimitsFailure = createAction<PayloadData<Error, UpdateLicenseLimits$Request, true>>('LICENSE_LIMITS__UPDATE_LICENSE_LIMITS__FAILURE');

export const updateLicenseLimitsActions = [
    updateLicenseLimitsRequest,
    updateLicenseLimitsSuccess,
    updateLicenseLimitsFailure
] as const;

/**
 * @param {number} meta.licenseId
 * @param {Array<Limit>} meta.limit
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateLicenseLimits = (meta: UpdateLicenseLimits$Request, config?: UpdateLicenseLimits$Config) => {
    return {
        CALL_API: {
            types: updateLicenseLimitsActions,
            method: ApiMethods.PATCH,
            endpoint: `/web-api/licenses/${meta.licenseId}/limits`,
            TRANSPORT_REQUEST_BODY: meta.limit,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

